/* eslint-disable */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
  WritableSignal,
} from "@angular/core";
import { BasicFormInputComponent } from "../../basic/basic-form-input.component";
import { CabFileInputService } from "../../service/cab-file-input.service";
import { UntilDestroy } from "@ngneat/until-destroy";
import { HttpErrorResponse, HttpEventType } from "@angular/common/http";
import { ConfirmationDialogService } from "@core/services/confirm-modal.service";
import { finalize } from "rxjs/operators";
import { CabLabelComponent } from "../cab-label/cab-label.component";
import { CommonModule, NgClass, NgStyle } from "@angular/common";
import { FileSplitPipe } from "@shared/pipe/file-split.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { ToastService } from "@core/services/toast.service";
import { EBucketNames } from "@core/enums/EBucketNames.enum";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-cab-file-input",
  templateUrl: "./cab-file-input.component.html",
  styleUrls: ["./cab-file-input.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NgClass,
    CabLabelComponent,
    NgStyle,
    FileSplitPipe,
    TranslateModule,
  ],
})
export class CabFileInputComponent extends BasicFormInputComponent {
  @Input() previewFile = false;
  @Input() acceptType: string;
  @Input() bucketName: EBucketNames = EBucketNames.ACT;
  @Input() confirmDialogText = "CONFIRMATION.DELETE";
  @Input() limit = 10; // mb
  @Input() readonly = false;
  @Output() imagesData = new EventEmitter<string>();
  readonly SWITCH_UPLOADING = "SWITCH_UPLOADING";
  readonly SWITCH_FILE = "SWITCH_FILE";
  readonly SWITCH_NO_FILE = "SWITCH_NO_FILE";
  private cdr = inject(ChangeDetectorRef);
  protected cabFileInputService = inject(CabFileInputService);
  private _confirmModalService = inject(ConfirmationDialogService);
  private _toastService = inject(ToastService);

  isUploading = signal(false);
  progress: WritableSignal<number> = signal(0);
  file = null;
  fileName: WritableSignal<string | undefined> = signal("");
  preview = signal("");
  currentFile?: File;

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const file = (inputElement.files as FileList)[0];
    if (file.size > this.limit * 1024 * 1024) {
      this.formControl.setErrors({
        maxFileSize: { size: this.limit + "MB" },
      });
      this.formControl.markAllAsTouched();
      return;
    }
    this.preview.set("");
    if (file) {
      this.preview.set("");
      this.currentFile = file;
      this.isUploading.set(true);
      this.cabFileInputService
        .uploadFile({ file }, this.bucketName)
        .pipe(
          finalize(() => {
            this.isUploading.set(false);
          })
        )
        .subscribe({
          next: (res) => {
            this.progress.set(res.progress);
            if (res.eventType == HttpEventType.Response) {
              this.formControl.patchValue(
                `${res.response?.fileName}*${res.response?.fileId}`
              );
              this.cdr.markForCheck();
            }
          },
          error: (err: HttpErrorResponse) => {
            this._toastService.error(err?.error?.message ?? "");
          },
        });
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.preview.set(e.target.result);
        this.imagesData.emit(e.target.result);
      };
      reader.readAsDataURL(this.currentFile);
    }
  }

  remove() {
    this._confirmModalService
      .open({ title: "CONFIRMATION.CONFIRM", message: this.confirmDialogText })
      .then((confirm) => {
        if (confirm) {
          this.imagesData.emit("");
          this.clear();
        }
      });
  }

  clear() {
    this.formControl.patchValue(null);
    this.cdr.detectChanges();
  }

  getSwitchElement() {
    if (this.isUploading()) {
      return this.SWITCH_UPLOADING;
    }
    if (this.formControl.value) {
      return this.SWITCH_FILE;
    }

    return this.SWITCH_NO_FILE;
  }

  downloadFile() {
    this.cabFileInputService.downloadFile(this.formControl.value.split("*"));
  }
}
